export const QUICK_SETUP_REQUEST = 'QUICK_SETUP_REQUEST';
export const QUICK_SETUP_SUCCESS = 'QUICK_SETUP_SUCCESS';
export const QUICK_SETUP_FAILURE = 'QUICK_SETUP_FAILURE';
